import React, { useEffect, useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { supabase } from '../../services/supabaseClient';
import { getBusinessTypeNames } from '../../utils/registrationDocuments';

const UnitUsaha = () => {
    const { session } = useAuth();
    const [businessData, setBusinessData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let isMounted = true;

        const fetchBusinessData = async () => {
            if (!session?.user?.id) return;

            try {
                setIsLoading(true);

                // Fetch data menggunakan Relational Join Supabase
                const { data: regData, error: regError } = await supabase
                    .from('registrations')
                    .select(`
                        pesantren_name,
                        other_business_text,
                        registration_business_types (master_business_types (name, sort_order))
                    `)
                    .eq('user_id', session.user.id)
                    .single();

                if (regError) throw regError;

                if (isMounted) {
                    setBusinessData({
                        pesantren_name: regData.pesantren_name,
                        business_type_names: getBusinessTypeNames(regData),
                        other_business_text: regData.other_business_text
                    });
                }

            } catch (err) {
                console.error('Error fetching business unit:', err);
                if (isMounted) setError(err.message);
            } finally {
                if (isMounted) setIsLoading(false);
            }
        };

        fetchBusinessData();

        return () => { isMounted = false; };
    }, [session]);

    if (isLoading) {
        return (
            <div className="p-6 flex justify-center items-center h-64">
                <p className="text-gray-500 animate-pulse">Memuat data unit usaha...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="p-6">
                <div className="bg-red-50 text-red-600 p-4 rounded-md">
                    Gagal memuat data: {error}
                </div>
            </div>
        );
    }

    return (
        <div className="p-6 max-w-4xl mx-auto">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6 gap-4">
                <div>
                    <h1 className="text-2xl font-bold text-gray-800">Unit Usaha</h1>
                    <p className="text-sm text-gray-500">Bidang usaha non-pendidikan yang dijalankan oleh {businessData?.pesantren_name || 'Pesantren'}.</p>
                </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-6 py-4 border-b border-gray-100 bg-gray-50">
                    <h2 className="text-sm font-semibold text-gray-700">Bidang Usaha Terdaftar</h2>
                </div>

                <div className="divide-y divide-gray-100">
                    {(businessData?.business_type_names || []).length === 0 ? (
                        <div className="p-6 text-sm text-gray-500">Bidang usaha tidak ditemukan.</div>
                    ) : (
                        businessData.business_type_names.map((name) => (
                            <div key={name} className="p-6 hover:bg-gray-50 transition-colors">
                                <div className="flex items-center gap-3 mb-1">
                                    <h3 className="text-lg font-medium text-gray-900">{name}</h3>
                                    <span className="px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                                        Bidang Usaha
                                    </span>
                                </div>
                                {name.toLowerCase() === 'lainnya' && businessData.other_business_text && (
                                    <p className="text-sm text-gray-500">{businessData.other_business_text}</p>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

export default UnitUsaha;